export var ReportNamingConvention;
(function (ReportNamingConvention) {
    ReportNamingConvention["TRUNCATED"] = "truncated";
    ReportNamingConvention["TICKER"] = "ticker";
    ReportNamingConvention["LETTERING"] = "lettering";
    ReportNamingConvention["CUSTOM"] = "custom";
})(ReportNamingConvention || (ReportNamingConvention = {}));
